/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type { AccountTransaction } from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Get transactions for an account.
 */
export const getAccountTransactions = (
  billingAccountId: number,
  options?: SecondParameter<typeof backofficeRequest<AccountTransaction[]>>,
) => {
  return backofficeRequest<AccountTransaction[]>(
    { url: `/api/v1/accounts/${billingAccountId}/transactions`, method: "GET" },
    options,
  )
}
export type GetAccountTransactionsResult = NonNullable<
  Awaited<ReturnType<typeof getAccountTransactions>>
>
